<template>
  <span
    :class="{
      [name]: true,
    }"
  ></span>
</template>

<script setup lang="ts">
// Ptc Font icons e.g `ptc-burger-menu` are generated
// in inertia
defineProps<{
  name: string;
}>();
</script>
